import VueSocialSharing from 'vue-social-sharing';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  return nuxtApp.vueApp.use(VueSocialSharing);
});
